import Model from '../../ModelBinding/Model';
import RateCollection from './RateCollection';
import RateScoreCollection from '../RateScore/RateScoreCollection';
import RateForm from '../RateForm/RateForm';

export default class Rate extends Model {
  public average?: number;
  public average_by_group?: number;
  public average_by_digression?: number;
  public comment?: string;
  public scores?: RateScoreCollection;
  public form?: RateForm;

  bind() {
    this.average = this.getFloatAttribute('average');
    this.average_by_group = this.getFloatAttribute('average_by_group');
    this.average_by_digression = this.getFloatAttribute('average_by_digression');
    this.comment = this.getStringAttribute('comment');
    this.scores = this.getRelationCollection('scores', RateScoreCollection) as RateScoreCollection;
    this.form = this.getRelation('form', RateForm);
  }

  static getCollection() {
    return RateCollection;
  }
}
